<template>
  <v-card style="width: 95%; margin: 0 auto">
    <v-toolbar color="green">
      <h4 class="title text-white">
        {{ this.$route.params.id == 'add' ? '填写第三方软件信息' : '编辑第三方软件信息' }}
      </h4>
      <v-spacer></v-spacer>
      <v-btn dark color="grey" @click="$router.push({ path: '/thirdPartySoft' })">返回</v-btn>
      <v-btn class="ml-4" color="success" @click.stop="submit">{{ this.$route.params.id == 'add' ? '创建' : '保存'}}</v-btn>
    </v-toolbar>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <v-card class="pa-6">
            <div class="loigWrap">
              <div class="picture-container">
                <div class="picture">
                  <img class="picture-src" :src="logImg == '' || logImg == undefined ? LocalscoureImg : logImg" />
                  <input class="picture-input" type="file" @change="upload" />
                </div>
                <p class="logTitle">选择封面</p>
              </div>
              <p style="color: red; text-indent: 22px" class="logintitle">
                推荐封面尺寸为190(高)*340(宽)的封面图片
              </p>
            </div>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>

            <v-text-field v-model="form.name" label="软件名称 *" :rules="[v => !!v || '软件名称不能为空']" dense></v-text-field>
            <v-textarea v-model="form.description" label="软件简介" rows="1" auto-grow dense></v-textarea>
            <v-text-field v-model="form.university" label="参与院校" dense></v-text-field>
            <v-text-field dense v-model="form.manager" label="负责人 *" :rules="[v => !!v || '负责人不能为空']"></v-text-field>

            <v-row>
              <v-col cols="6">
                <v-switch label="支持考核模式" v-model="form.examModeEnabled" color="purple"></v-switch>
              </v-col>
              <v-col cols="6">
                <v-switch label="支持存档" v-model="form.saveDocumentEnabled" color="purple"></v-switch>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="pa-6">
            <div>客户端（各个版本）</div>
            <v-btn class="mt-3" icon color="primary" @click.stop="handleAddVersion">
              <v-icon>add</v-icon>
            </v-btn>
            <v-card class="pa-4 mb-2" v-for="(item, index) in versions" :key="item.id">
              <v-select dense @click="handlePlatformClick(item.id)" @change="val => handleSelectPlatform(val, item)"
                v-model="item.platform" :items="tagAll[item.id]" label="发布平台" item-color="purpe" item-text="label"
                item-value="value" multiple :rules="[v => !(v.length === 0) || '请选择软件所属平台']" no-data-text="无可发布版本"></v-select>
              <div v-if="!checkIsWebGL(item)">
                <v-file-input dense accept=".zip" label="软件包" placeholder="仅支持zip压缩包"
                  @change="e => handleCheckFile(e, item)"></v-file-input>
                <v-text-field dense label="软件包版本号" v-model="item.version"></v-text-field>
                <v-text-field dense label="应用程序名" v-model="item.appName"></v-text-field>
              </div>
              <v-text-field v-else dense label="WebGL访问地址" v-model="item.href"></v-text-field>
              <div class="mb-3" style="display: flex;justify-content: flex-start;align-items: center;">
                <v-btn icon color="primary" @click.stop="handleAddSoftArgs(item)">
                  <v-icon>add</v-icon>
                </v-btn>
                自定义参数
              </div>

              <div v-for="(arg, arg_index) in item.softArgs" :key="`arg_${arg_index}`" class="d-flex">
                <v-text-field dense label="参数属性" v-model="arg['prop']"></v-text-field>
                <v-text-field dense class="ml-3" label="参数值" v-model="arg['value']"></v-text-field>
                <v-btn icon color="error" @click.stop="handleRemoveArgs(item, arg_index)">
                  <v-icon>remove</v-icon>
                </v-btn>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon color="red" @click="handleRemoveVersionItem(index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="pa-6">
            <v-btn color="success" small @click="handleDownloadTemplate">下载录入模板</v-btn>
            <v-btn class="ml-4" color="success" small @click="handleWriteExcel">导出</v-btn>
            <v-file-input accept=".xlsx" label="课程大纲" @change="handleUploadCourseTree"></v-file-input>
            <v-row>
              <v-col cols="12" md="6">
                <v-card-text>
                  <v-treeview dense @update:active="(val) => treeItem = val" :items="form.courseTree"
                    selected-color="indigo" activatable return-object>
                  </v-treeview>
                </v-card-text>
              </v-col>

              <v-divider vertical></v-divider>

              <v-col cols="12" md="6">
                <v-card-text>
                  <div v-if="treeItem.length === 0" key="title"
                    class="text-h6 font-weight-light grey--text pa-4 text-center">
                    选择节点修改附加参数
                  </div>

                  <v-scroll-x-transition group hide-on-leave>
                    <div v-for="(selection, i) in treeItem" :key="i" class="ma-1">
                      <v-textarea solo v-model="selection.json" label="json参数"></v-textarea>
                    </div>
                  </v-scroll-x-transition>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="uploadFileListVisible" persistent :overlay="true" max-width="500px"
      transition="dialog-transition">
      <v-card class="pa-6">
        <h5>上传软件进度</h5>
        <div v-for="item in needUploadFileList" :key="item.id"
          style="display: flex;justify-content: space-between;align-items: center;">
          <span>{{ `${item.appName} ${item.version}` }}</span>
          <span>{{ item.progress }} %</span>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { SlideYDownTransition } from 'vue2-transitions';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', required);
import { ossMultipartUpload } from '@/api/common';
import { upload } from '@/api/user';
import {
  getThirdPartySoftById,
  addThirdPartySoft,
  updateThirdPartySoft,
} from '@/api/course/thirdPartySoft';
const XLSX = require('xlsx');

export default {
  components: {
    SlideYDownTransition,
  },
  data() {
    return {
      LocalscoureImg: require('/public/img/log.png'),
      versions: [],
      logImg: '',
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      valid: true,
      name: '',
      select: null,
      tab: null,
      panel: 0,
      softArgs: [
        {
          prop: '',
          value: '',
        },
      ],
      form: {
        softType: '',
        courseTree: [],
      },
      treeItem: [],
      tagAll: {},
      originTagAll: [
        {
          label: 'PC',
          value: 'PC',
        },
        {
          label: 'VR',
          value: 'VR',
        },
        {
          label: 'WebGL',
          value: 'WebGL',
        },
        {
          label: 'ZSpace',
          value: 'ZSpace',
        },
        {
          label: 'KMAX',
          value: 'KMAX',
        },
      ],
      softArgsDict: {},
      fileDict: {},
      uploadFileListVisible: false,
      needUploadFileList: [],
      progressDict: {}
    };
  },
  computed: {
    tagList() {

    }
  },
  mounted() {
    this.init();
  },

  methods: {
    handleAddVersion() {
      const uuid = this.uuid();
      this.versions.push({
        id: uuid,
        version: 'v1.0',
        appName: 'default',
        platform: [],
        url: '',
        softArgs: [],
      });
      this.softArgsDict[uuid] = [];
      this.initTag()
    },
    handleRemoveVersionItem(index) {
      this.versions.splice(index, 1);
    },
    handleSelectPlatform(val, item) {
      this.initTag()
      this.$forceUpdate()
    },
    handleFilterPlatform(id) {
      const list = this.versions.map(item => item.id === id ? [] : item.platform).flat()
      return this.originTagAll.filter(item => list.includes(item.value))
    },
    handlePlatformClick(item) {
      return this.handleSelectPlatform(item.platform, item)
    },
    checkIsWebGL(item) {
      const platform = item.platform ?? []
      return platform.includes('WebGL')
    },
    handleCheckFile(file, item) {
      this.fileDict[item.id] = file;
    },
    handleAddSoftArgs(item) {
      item.softArgs.push({
        prop: '',
        value: '',
      });
    },
    handleRemoveArgs(item, index) {
      item.softArgs.splice(index, 1);
    },
    resetform() {
      this.$refs.form.validate();
    },
    upload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = e => {
        // this.user.avatar = e.target.result;
      };
      reader.readAsDataURL(file);
      let type = file.type.split('/') && file.type.split('/')[1] ? file.type.split('/')[1] : '';
      if (!['jpeg', 'jpg', 'png'].includes(type)) {
        this.$message.warning('请选择正确的图片格式');
        return;
      }
      let formData = new FormData();
      formData.append('avatar', file);
      upload(formData).then(res => {
        if (res.code === '200') {
          this.logImg = res.data.url;
          this.form.cover = res.data.url;
        }
      });
    },

    initTag() {
      const arrCheckedPlatform = this.versions.flatMap(item => item.platform ?? [])

      this.versions.forEach(item => {
        let arr = item.platform ?? []
        let filterArr = this.originTagAll.filter(data => !arrCheckedPlatform.includes(data.value))
        if (arr.includes('WebGL')) {
          this.tagAll[item.id] = ['WebGL'];
        } else if (arr.length > 0) {
          this.tagAll[item.id] = arr.concat(filterArr).filter(item => item.value !== 'WebGL');
        } else {
          this.tagAll[item.id] = arr.concat(filterArr)
        }
      })
    },
    async init() {
      const { id: _id } = this.$route.params;
      // add代表是添加，不需要请求
      if (_id === 'add') return;
      let _this = this;
      getThirdPartySoftById({
        _id,
      }).then(res => {
        _this.form = res.data;
        this.logImg = res.data.cover;
        this.softArgs = res.data.softArgs;
        this.versions = res.data.softVersions ?? [];
        this.initTag()
      });
    },
    async submit() {
      this.form.softArgs = this.softArgs;
      this.needUploadFileList = this.versions
        .filter(item => this.fileDict[item.id])

      await this.checkUploadFile()

      this.form.softVersions = this.versions;
      // 判断使用哪个方法，有_id代表是修改
      const handleFunc = this.form._id ? updateThirdPartySoft : addThirdPartySoft;
      await handleFunc(this.form);
      this.$notify({
        timeout: 500,
        message: '操作成功!',
        horizontalAlign: 'center',
        verticalAlign: 'bottom',
        type: 'success',
      });
      const _this = this;
      const timeout = setTimeout(() => {
        _this.$router.push({ path: '/thirdPartySoft' });
        clearTimeout(timeout);
      }, 500);
    },
    async checkUploadFile() {
      if (this.needUploadFileList.length > 0) {
        this.uploadFileListVisible = true;

        await Promise.all(
          this.needUploadFileList.map(item => {
            return ossMultipartUpload({
              path: `/ThirdApp/${item.id}/${item.version}/${item.appName}.zip`,
              file: this.fileDict[item.id],
              progress: (p, cpt, res) => {
                item.progress = (p * 100).toFixed(2)
                this.$forceUpdate()
              }
            })
          })
        );
      }
      return;
    },
    /**
     * 生成uuid
     */
    uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    async handleUploadCourseTree(file) {
      const reader = new FileReader();
      reader.onload = e => {
        const base64Data = e.target.result;
        const workbook = XLSX.read(base64Data, { type: 'base64' });
        // 读取Excel文件
        const sheetName = workbook.SheetNames[0]; // 假设我们要读取第一个工作表
        const sheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(sheet, { header: 1 }); // 假设第一行是表头
        const data = excelData.slice(1);
        let treeArr = [];
        const getRowLevel = row => {
          for (let i = 0; i < 4; i++) {
            if (row[i]) return i;
          }
        };
        const indexDict = [];
        for (let i = 0; i < 4; i++) {
          indexDict.push(-1);
        }
        const setTreeItem = (arr, item = {}, targetDeep = 0, dict = [], deep = 0) => {
          if (targetDeep === deep) {
            arr.push(item);
            dict[deep] = arr.length - 1;
            return;
          }
          const targetItem = arr[dict[deep]];
          setTreeItem(targetItem.children, item, targetDeep, dict, deep + 1);
        };
        for (let i = 0; i < data.length; i++) {
          const row = data[i];
          const curRowLevel = getRowLevel(row);

          setTreeItem(
            treeArr,
            {
              id: this.uuid(),
              name: row[curRowLevel],
              json: row[4],
              children: [],
            },
            curRowLevel,
            indexDict
          );
        }
        this.form.courseTree = treeArr;
        console.log(JSON.stringify(treeArr));
      };
      reader.readAsArrayBuffer(file);
    },

    handleWriteExcel() {
      // 将 JSON 数据转换为 Excel 工作表
      const flattenTree = (tree, deep = 0) => {
        let flatArray = [];

        const traverse = (node, currentDeep) => {
          flatArray.push({
            id: node.id,
            name: node.name,
            json: node.json,
            deep: currentDeep
          });
          node.children.forEach(child => traverse(child, currentDeep + 1));
        }

        tree.forEach(root => traverse(root, deep));
        return flatArray;
      }

      const jsonToExcel = (jsonData) => {
        const worksheet = XLSX.utils.json_to_sheet(jsonData, {
          header: ["1级", "2级", "3级", "4级", "附加数据"],
        });

        return worksheet;
      }

      // 将工作表写入 Excel 文件
      const writeToExcel = (worksheet) => {
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, { type: 'buffer', bookType: 'xlsx' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'output.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
      const flatData = flattenTree(this.form.courseTree);
      // 转换并写入 Excel 文件
      const worksheet = jsonToExcel(flatData.map(row => {
        let obj = {}
        obj[`${row.deep + 1}级`] = row.name;
        obj['附加数据'] = row.json;
        return obj;
      }));
      writeToExcel(worksheet);
    },
    handleDownloadTemplate() {
      window.location.href = 'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/temp/template.xlsx'
    }
  },
};
</script>

<style lang="css" scoped>
.picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}

.picture-container .description {
  margin: 0;
  margin-bottom: 0.5rem;
}

.md-checked>>>.md-switch-container {
  background: #4caf50 !important;
}

.switchHightWrap {
  margin-left: 10px;
}

.md-checked>>>.md-switch-container .md-switch-thumb {
  border: 1px solid #4caf50 !important;
}

.scoureImg {
  width: 340px;
  height: 190px;
}

.scoureImgWrap {
  margin-top: 10px;
  margin-bottom: 20px;
}

.tabTitle {
  font-size: 18px;
}

.el-upload-list {
  padding-left: 0px !important;
}

.loigWrap {
  padding: 20px 0;
  float: left;
  width: 40%;
}

.picture-input {
  position: absolute;
  width: 340px;
  height: 190px !important;
  top: 0;
  left: 0;
  opacity: 0;
}

@media (max-width: 800px) {
  .loigWrap {
    margin-top: 70px !important;
  }
}

@media (max-width: 1200px) {
  .loigWrap {
    margin-top: 70px !important;
  }

  .loigWrap /deep/ .el-upload-list {
    padding-left: 0px !important;
  }

  .logintitle {
    margin-top: -80px;

    width: 170px;
    text-align: left;
  }
}

@media (max-width: 1400px) {
  .logintitle {
    margin-top: 30px;

    width: 170px;
    text-align: left;
  }

  .loigWrap {
    margin-top: 20px;
  }

  .loigWrap /deep/ .picture-src {
    width: 180px;
    height: 140px !important;
  }

  .loigWrap /deep/ .picture {
    max-width: none;
    border-radius: 0;
    width: 180px;
    height: 140px;
    margin: 0px;
  }

  .loigWrap /deep/ .logTitle {
    width: 180px;
    text-align: center;
  }
}

.inputWrap {
  float: left;
  width: 60%;
}

@media (max-width: 600px) {
  .loigWrap {
    /* margin-top: 70px !important; */
    width: 100%;
    height: auto;
    margin-top: 0px !important;
    padding: 0px;
  }

  .logintitle {
    /* margin-top: 0px; */
    margin: 0 auto;
  }

  .logTitle {
    margin: 0 auto;
  }

  .inputWrap {
    float: left;
    width: 100%;
  }

  .loigWrap .picture {
    width: 100%;
  }

  .loigWrap .picture-src {
    width: 100%;
  }
}

.picture-src {
  width: 340px;
  height: 190px !important;
}

.picture {
  max-width: none;
  border-radius: 0;
  width: 340px;
  height: 190px;
  margin: 0px;
}

.description {
  text-align: left;
}

.logTitle {
  width: 340px;
  text-align: center;
}
</style>
